/**
 * If mobile it opens the navigation as sidebar, when clicking somewhere else
 * when the sidebar is open it hides automatically.
 */

const navbarInit = () => {
  // Elements
  const header: HTMLElement = document.querySelector('.header');
  const headerMenus: NodeListOf<HTMLElement> = header.querySelectorAll('.header__menu');
  const headerClose: HTMLElement = header.querySelector('.header__close');
  const toggler: HTMLElement = header.querySelector('.header__toggler');

  // Strings
  const headerActive: string = 'header--active';
  const headerDesktop: string = 'header--desktop';
  const headerMobile: string = 'header--mobile';
  const headerScrolled: string = 'header--scrolled';
  const togglerActive: string = 'toggler--active';

  // Mediaqueries
  const mediaQuery: MediaQueryList = window.matchMedia('(max-width: 991.95px)');

  // Add class to header relative to current breakpoint
  const classForBreakpoint = (): void => {
    if (mediaQuery.matches) {
      header.classList.remove(headerDesktop);
      header.classList.add(headerMobile);
    } else {
      header.classList.remove(headerMobile);
      header.classList.add(headerDesktop);
    }
  };
  classForBreakpoint();

  window.addEventListener('resize', classForBreakpoint);

  // Listen for scroll position and add or remove class accordingly
  window.addEventListener('scroll', (): void => {
    if (window.scrollY > 0) {
      header.classList.add(headerScrolled);
    } else {
      header.classList.remove(headerScrolled);
    }
  }, { passive: true });

  // Add active class on click
  // and stop propagation
  toggler.addEventListener('click', (e: Event): void => {
    e.stopPropagation();
    header.classList.add(headerActive);
  });

  // Remove active class on click
  headerClose.addEventListener('click', (e: Event): void => {
    e.stopPropagation();
    header.classList.remove(headerActive);
  });

  // Stop propagation when clicking on
  // element with .header__menu class
  [...headerMenus].forEach((menu): void => {
    menu.addEventListener('click', (e: Event): void => {
      e.stopPropagation();
    });
  });

  // Remove active class when clicked somewhere else
  document.addEventListener('click', (): void => {
    header.classList.remove(headerActive);
    toggler.classList.remove(togglerActive);
  });
};

export default navbarInit;
